import React from "react";
import { ArrowUpRight } from "lucide-react";
import { PWA } from "@/constants/testIds";
import Reveal from "./Reveal";

const BG =
  "https://images.pexels.com/photos/36887750/pexels-photo-36887750.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=2000";

const FinalCta = () => {
  const go = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      data-testid={PWA.finalCtaSection}
      className="relative overflow-hidden text-[#FAF9F6] noise-overlay"
    >
      <div className="absolute inset-0">
        <img src={BG} alt="" className="w-full h-full object-cover kenburns" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#121212]/95 via-[#121212]/80 to-[#5C4033]/55" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-28 md:py-36">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-[11px] tracking-[0.4em] uppercase text-[#D9B27F] font-semibold mb-6">
              — Let's Build Something Real
            </p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-7xl leading-[1.03] tracking-tight">
              Ready to bring your<br />
              <span className="italic text-[#D9B27F]">custom wood project</span> to life?
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="mt-7 text-[#FAF9F6]/80 text-base md:text-lg max-w-xl font-light leading-relaxed">
              Whether it's a single statement table or a full home of built-ins — let's design
              it together. Free consultation. Honest pricing. Real craftsmanship.
            </p>
          </Reveal>
          <Reveal delay={360}>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button onClick={go} className="btn-gold" data-testid={PWA.finalCtaButton}>
                Start Your Project
                <ArrowUpRight className="w-4 h-4" />
              </button>
              <a href="tel:+13059827191" className="btn-outline-light" data-testid="pwa-final-cta-call">
                Call 305-982-7191
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
